const messages = {
    ru: {
        EMPTY_FIELD: 'Поле обязательно для заполнения',
        INVALIDATED_EMAIL: 'Введите корректный адрес эл. почты',
        INVALIDATED_PHONE: 'Введите корректный номер телефона',
        INVALIDATED_SELECT: 'Выберите значение из списка',
        INVALIDATED_EQUALS: 'Значение полей должно совпадать',
        INVALIDATED_ADDRESS: 'Введите корректный адрес',
    },
    en: {
        EMPTY_FIELD: 'This field must not be empty',
        INVALIDATED_EMAIL: 'Enter a valid email address',
        INVALIDATED_PHONE: 'Enter a valid phone number',
        INVALIDATED_SELECT: 'Choose an option',
        INVALIDATED_EQUALS: 'Values must be equal',
        INVALIDATED_ADDRESS: 'Enter a valid address',
    },
};

export default messages;
